import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { laughlinConfig } from "./data";

export default function LaughlinPage() {
  return <OregonCityPageTemplate config={laughlinConfig} />;
}